import { render, staticRenderFns } from "./EmailPasswordReset.vue?vue&type=template&id=23ff4f51"
import script from "./EmailPasswordReset.vue?vue&type=script&lang=js"
export * from "./EmailPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports